import { FC, useState } from 'react';
import { Button } from '@base/lib/Button';
import { flushCache } from 'mod/checkIn/service';
import { useStoreState } from 'base/store';
import { useCheckInContext } from 'mod/checkIn/useCheckInContext';

export const ClearRecord: FC = () => {
    const { envName } = useStoreState('rootStore');
    const { data, fetchData } = useCheckInContext();
    const [loading, setLoading] = useState<boolean>(false);

    const hancleClick = async () => {
        setLoading(true);
        try {
            await flushCache(data!.activityGid);
            fetchData();
        } catch (e) {

        }
        setLoading(false);
    };

    return envName === 'prod' || !data.activityGid ? null : (
        <div className={'text-center mt-4'}>
            <Button onClick={hancleClick} loading={loading}>Clear Record</Button>
        </div>
    )
};
